import { FeatureFlag } from '@/infra/feature-flag/feature-flag'
import errorMonitor from '@/infra/tracking/error-monitor'
import { Spinner } from '@/presentation/components'
import useAccount from '@/presentation/hooks/auth/use-account'
import { useLDClient } from 'launchdarkly-react-client-sdk'
import { Fragment, useState } from 'react'
import { useQuery } from 'react-query'

const KEY = 'app-gateway'

type AppGatewayProps = {
  children: React.ReactNode
}

export default function AppGateway({ children }: AppGatewayProps) {
  const [account] = useAccount()
  const ldClient = useLDClient()
  const [initialized, setInitialized] = useState(false)

  useQuery(
    KEY,
    () => {
      FeatureFlag.Helper.identifyClient(ldClient, account!)
        .then(() => {
          errorMonitor.identifyUser(account)
        })
        .then(() => {
          setInitialized(true)
        })
    },
    {
      enabled: !!account && !initialized,
      staleTime: 2000
    }
  )

  return initialized ? <Fragment>{children}</Fragment> : <Spinner fullScreen />
}
